import MainSkills from "../../components/Forms/MainSkills";
import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";
import AwardsList from "./AwardsListe";
import EmployeeofDepartmentList from "./EmployeeofDepartmenList";
import LeaderofQuarterList from "./LeaderofQuarterList";
import StarofYearList from "./StarofYearList";



function EmployeeofDepartmentListMain() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <EmployeeofDepartmentList/>
            </BasicCard>
        </>
    )
}
export default EmployeeofDepartmentListMain;